import { ResponseSuccess } from "@forwardflow/types"
import { apiGet } from "../Axios/configs"
import OrganizationService from "../OrganizationService"

export default class ConversationalAIService {
  static async getConversationalAISignedUrl() {
    const config = await OrganizationService.getDefaultConfigurations()
    const elevenlabsApiKey = config.elevenLabsApiKey
    const data = await apiGet<ResponseSuccess<{ signed_url: string }>>({
      apiPath: 'https://api.elevenlabs.io/v1/convai/conversation/get-signed-url',
      external: true,
      config: {
        params: {
          agent_id: 'agent_01k0mdwd63fcn9vez2z3xhg9pj'
        },
        headers: {
          'xi-api-key': elevenlabsApiKey
        }
      },
    })
    return data
  }
}